import { withStyles } from "@material-ui/core";
const styles = () => ({
  confirmDialogContent: {
    display: "flex",
    flexDirection: "column",
  },
});
const ConfirmationDialogContent = ({ classes, isGroupedPickups }) => (
  <div className={classes.confirmDialogContent}>
    <span>
      Please unassign the pickup before voiding.
      <br />
      {isGroupedPickups &&
        'All pickups in the group will be unassigned together. To unassign only selected ones, ungroup the pickup first.'}
    </span>
  </div>
);

export default withStyles(styles)(ConfirmationDialogContent);
